import React, { Component } from 'react';
import ReactPixel from 'react-facebook-pixel';
import axios from 'axios';
import { serverIp, ref, firebaseAuth, base, shirtSizes, orderSourceOptions, replacementOptions, replacementReasonOptions, bringJerseyOptions, orderTypeOptions, genderOptions, sendNewOrderSmsOptions } from '../../config/constants.js'
import LandingPageCards from './LandingPageCards'
import OrderFormUI from './OrderFormUI'
import * as moment from 'moment';
import { OrderComplete, LandingPageModal } from './OrderFormComps'
import NewConfirmOrder from './NewConfirmOrder'
import { getOrderNumberAndUpdateCounterNew } from '../../Utilities/FireBaseUtils'
import { getOrderNumberAndSaveOrder } from './SaveOrderFunction/SaveOrderFunction';
import { TrackFbClicks } from '../../Utilities/Utils'
//'../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils'
import { checkAdminEmail } from '../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import {Image, } from 'semantic-ui-react'



import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: false });


export default class OrderForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemTypeSelected: false,
            itemSelected: '',
            itemTypeDescription: '',
            email: '',
            specialItems: false,
            algoliaUser: '',
            //ORDER DETAILS---
            quantity: 'blank',
            color: 'blank',
            shirtSize: 'blank',
            shirtColor: 'blank',
            shirtText: '',
            shirtBackText: '',
            shirtType: 'round_neck',
            phone: '',
            phone2: '',
            name: '',
            address: '',
            special_instructions: '',
            pricing_notes: '',
            // --- FB STUFF
            adset: 'none',
            //--------
            formHasError: false,
            formErrors: [],
            formErrorFieldArray: '',
            shirtSizeError: false,
            shirtColorError: false,
            shirtTypeError: false,
            orderConfirming: false,
            orderObject: '',
            orderComplete: false,
            //SHIRT SIZE QTYS
            shirtSizeAndQtys: '',
            //FILE FILE UPLOAD 
            uploadComplete: false,
            showUploadFile: false,
            actualFileName: '',
            imageUrl: 'none',
            modalOpen: false,
            //new order details
            shirtColor: '',
            shirtSize: '',

            numOrders: 1,
            admin: false,
            shirtColors: [],
            childsAge3: '',
            //SHIRTISIZES
            // shirtSizes:[],
            orderNum: '',
            //SINGLE ORDER ARRAY
            singleOrderArray: [],
            //REPLACEMENTS
            orderSource: '',
            replacement: '',
            replacementReason: '',
            bringJersey: 'no',
            orderType: 'none',
            gender: 'none',
            cardObject: '',
            sendNewOrderSms: 'yes',
            couponCode: '',
            salesPeopleChoices: [],
            salesPerson: '',
            sendDesignToSales: false,
            sendDesignToSalesOptions: [
                { value: false, label: 'Send To Client', key: false, category: 'sendDesignToSales' },
                { value: true, label: 'Send To SalesPerson', key: true, category: 'sendDesignToSales' },
            ]
        }
    }


    /**
     * UPDATE THE SINGLE ORDER ARRAY
     */
    updateSingleOrderArray = (sentSingleOrderArray) => {
        console.log("main obx91 : +++++++++updateSingleOrderArray");
        console.log("sentSingleOrderArrays obx92 :" + sentSingleOrderArray.length);

        this.setState({
            singleOrderArray: sentSingleOrderArray,
            numOrders: sentSingleOrderArray.length
        })

        console.log("ssi5: obx92 whote shit:" + JSON.stringify(sentSingleOrderArray, null, 3));
    }

    saveAllSingleOrders = (mainOrderKey) => {
        console.log("ssi1 ++++++++++++ saveAllSingleOrders");
        console.log("ssi10 singleOrderArray size:" + this.state.singleOrderArray.length);
        console.log("ssi12 mainOrderKey:" + mainOrderKey);

        this.state.singleOrderArray.map((singleOrder) => {

            let singleOrderKey = ref.child('orders/' + mainOrderKey + '/singleOrders').push().key;

            // let singleOrderKey = ref.child('orders/' + mainOrderKey+ '/singleOrders'.push().key);
            console.log("ssi2 singleOrderKey:" + singleOrderKey);
            // this.setState({ newPostKey: newPostKey });

            ref.child('orders/' + mainOrderKey + '/singleOrders/' + singleOrderKey).set(singleOrder);

        })
    }

    componentDidMount() {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            let tempAdmin = false;


            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    //uid: user.uid
                })
            }


            if (this.props.match.params.campaign && this.props.match.params.fbId && this.props.match.params.adset) {
                console.log("fbx1 fbId is valid:" + this.props.match.params.fbId);
                TrackFbClicks(this.props.match.params.fbId, this.props.match.params.campaign, tempAdmin, "unkown_adset");

            } else if (this.props.match.params.campaign && this.props.match.params.fbId) {
                console.log("fbx1 fbId is valid:" + this.props.match.params.fbId);
                TrackFbClicks(this.props.match.params.fbId, this.props.match.params.campaign, tempAdmin, "unkown_adset");

            } else if (this.props.match.params.fbId) {
                console.log("fbx1 fbId is valid:" + this.props.match.params.fbId);
                // TrackFbClicks(this.props.match.params.fbId, camp tempAdmin);
                TrackFbClicks(this.props.match.params.fbId, "unknown", tempAdmin, "unkown_adset");
            }

            //SET FB CAMPAIGN NAME FROM URL..
            if (this.props.match.params.adset) {
                console.log("adset1 adset is valid:" + this.props.match.params.adset);

                this.setState({ adset: this.props.match.params.adset })
            }

            //THIS PROPS STUFF
            if (this.props.match.params.specialEntry) {
                console.log("munx15 specialEntry:" + this.props.match.params.specialEntry);
            } else {
                console.log("munx151 NO specialEntry:");
            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("sendDesignToSales1 ++++++ addx294 setAdminResult");
         console.log("sendDesignToSales1 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            admin: returnObject.isAdmin,
            //isAdmin: returnObject.isAdmin,
        })



        if (!returnObject.isAdmin) {
            console.log("infinix returnObject.isAdmin is false loading ReactPixel.pageView")
            ReactPixel.pageView();
        }
    }


    setShirtColorTypes = (itemSelected) => {
        console.log("tired - itemSelected:" + itemSelected);
        if (itemSelected !== 'cranes' && itemSelected !== 'jumper') {
            /**
            * GET NORMAL SHIRT COLORS
            */
            //SHIRT COLORS
            base.fetch('shirtColors', {
                context: this,
                asArray: true,
                state: 'normalShirtColors',
                queries: {
                    orderByChild: 'shirtColor',
                    equalTo: true
                },
                then(data) {
                    //  console.log(data);
                    this.setState({
                        shirtColors1: data,
                        shirtColors2: data,
                        shirtColors3: data
                    })
                }
            });
        } else if (itemSelected === 'cranes') {
            base.fetch('cranes/cranesColors', {
                context: this,
                asArray: true,
                then(data) {
                    //  console.log(data);
                    this.setState({
                        shirtColors1: data,
                        shirtColors2: data,
                        shirtColors3: data
                    })
                }
            });

        } else if (itemSelected === 'jumper') {
            console.log("tired - itemSelected jumper");

            base.fetch('shirtColors', {
                context: this,
                asArray: true,
                queries: {
                    orderByChild: 'jumper',
                    equalTo: true
                },
                then(data) {
                    console.log("tired2" + data);
                    this.setState({
                        shirtColors1: data,
                        shirtColors2: data,
                        shirtColors3: data
                    })
                }
            });
        }


    }

    /**
    * GET THE COLORS FOR A TEAM
    */
    getTeamJerseyColors = (teamName, orderNum) => {
        console.log("+++++++:getTeamJerseyColors - " + teamName);
        //SHIRT TYPES
        base.fetch('football/teams/' + teamName + '/colors', {
            context: this,
            asArray: true,
            then(data) {
                switch (orderNum) {
                    case 1:
                        this.setState({
                            shirtColors1: data
                        })
                        break;
                    case 2:
                        this.setState({
                            shirtColors2: data
                        })
                        break;
                    case 3:
                        this.setState({
                            shirtColors3: data
                        })
                        break;
                    default:
                        this.setState({
                            shirtColors1: data,
                            shirtColors2: data,
                            shirtColors3: data
                        })
                }


            }
        });
    }

    testingOrderNum = (sentOrderNum) => {
        console.log("testing orderNumber..:" + sentOrderNum);
    }


    /**
     * VALIDATE FORM
     */
    validateForm = () => {
        console.log("vll1 validateForm.....");

        let eventProperties = {
            itemType: this.state.itemSelected,
            imageUploaded: this.state.uploadComplete,
            admin: this.state.admin,
            totalShirts: this.getNewOrderObject().totalShirts,
            numOrders: this.state.numOrders,
        }

        //CHECK QUANTITY
        let tempFormHasError = false;
        let tempFormErrors = [];
        let tempFormErrorFieldArray = [];
        let temp_shirtSizeError = false;
        let temp_shirtColorError = false;
        let temp_shirtTypeError = false;

        console.log("quantity:" + this.state.quantity);



        /**
         * PHONE
         */
        if (!this.state.phone || this.state.phone === undefined || this.state.phone === '' || this.state.phone.length != 10) {
            tempFormHasError = true;
            console.log("phone error");
            //add to field list
            tempFormErrorFieldArray['phone'] = true;

            //ADD TO ARRAY
            tempFormErrors.push("Invalid Phone number, must be atleast 10 digits and be in format '07XXXXXXXX, please enter a uganda number or use the second phone feild for special numbers");
        }

        /**
         * ADDRESS
         */
        if (!this.state.address || this.state.address === undefined || this.state.address === '' || this.state.phone.length < 6) {
            tempFormHasError = true;
            console.log("address error");
            //add to field list
            tempFormErrorFieldArray['address'] = true;

            //ADD TO ARRAY
            tempFormErrors.push("Invalid Address");
        }

        /**
         * NAME
         */
        if (!this.state.name || this.state.name === undefined || this.state.name === '' || this.state.name.length < 4) {
            tempFormHasError = true;
            console.log("address error");
            //add to field list
            tempFormErrorFieldArray['name'] = true;

            //ADD TO ARRAY
            tempFormErrors.push("Invalid Name");
        }




        this.setState({
            formHasError: tempFormHasError,
            formErrors: tempFormErrors,
            formErrorFieldArray: tempFormErrorFieldArray,
            shirtColorError: temp_shirtColorError,
            shirtSizeError: temp_shirtSizeError,
            shirtTypeError: temp_shirtTypeError
        })

        console.log("vll12 errorFound:" + tempFormHasError);

        if (!tempFormHasError) {
            console.log("no errors submitting form");
            //this.saveOrder();
            //CONFIRM ORDER
            this.confirmOrder();
        } else {

            let errorString = JSON.stringify(tempFormErrorFieldArray);
            console.log("errorString:" + errorString);

            let eventProperties = {
                itemType: this.state.itemSelected,
                admin: this.state.admin,
                error: errorString
            }
            console.log("form error, not submitting form");
        }
    }

    /**
 * SUBMIT FORM
 */
    submitForm = (e) => {
        console.log("slx1 submitForm.....");
        e.preventDefault();

    }

    confirmOrder = () => {
        console.log("++++++ confirm Order");

        let eventProperties = {
            admin: this.state.admin,
            itemType: this.state.itemSelected,
            imageUploaded: this.state.uploadComplete,
            totalShirts: this.getNewOrderObject().totalShirts,
            numOrders: this.state.numOrders,
        }

        //    this.facebookConfirmOrder();
        this.setState({
            orderConfirming: true,
            orderObject: this.getNewOrderObject()
        })

    }



    /**
     * GET DESCRIPTION OF ORDER
     * 
     */
    getOrderDescription = (order, itemType) => {
        console.log("+++++++++++:getOrderDescription");
        console.log("itemType:" + itemType);

        let description = this.state.name
            + ' ordered ';

        let orderOne = '';

        if (itemType === 't-shirts') {
            console.log("its a tshirts");

            orderOne =
                order.qty + ' '
                + order.shirtColor + ' '
                + order.shirtSize + ' '
                + order.shirtType + ' '
                + 'shirts ';
            //+ 'with text:"' + this.state.shirtText + '" ';

        } else if (order.itemType === 'cranes') {
            console.log("its a jersey");

            orderOne =
                order.qty + ' '
                + order.shirtColor + ' '
                + order.shirtSize + ' '
                + ' cranes jersey '
                + ' with name: ' + order.jerseyName
                + ' and number : ' + order.jerseyNumber
                + ' ' + '" ';

        } else if (order.itemType === 'football') {
            console.log("its a jersey");

            orderOne =
                order.qty + ' '
                + order.shirtColor + ' '
                + order.shirtSize + ' '
                + order.teamSelection + ' '
                + ' jersey '
                + ' with name: ' + order.jerseyName
                + ' and number : ' + order.jerseyNumber
                + ' ' + '" ';
        }
        return orderOne;
    }

    /**
     * GET THE TOTAL NUMBER OF SHIRTS IN THE ORDER
     */
    countTotalShirts = () => {
        console.log("tx1 +++++++ - count total shirts");

        let totalShirts = 0;
        this.state.singleOrderArray.map((order) => {
            totalShirts += parseInt(order.qty);
            console.log("total is now:" + totalShirts);
        })

        console.log("tx2 total is now:" + totalShirts);
        return totalShirts;
    }

    /**
     * GET OBJECT OF THE ORDER
     */
    getNewOrderObject = (orderNum) => {

        var d = new Date();
        var n = d.toString();
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let tempOrderNum = orderNum ? orderNum : 'na';

        //CALC NUMBER OF ORDERS
        let tempNumOrders = this.state.numOrders;

        //GET ORDER DESCRIPTION
        let description = this.state.name
            + ' ordered '
            + this.state.quantity + ' '
            + this.state.shirtColor + ' '
            + this.state.shirtSize + ' '
            + 'shirts '
            + 'with text:"' + this.state.shirtText + '" '
            + 'Ph #1: ' + this.state.phone + ' '
            + 'Ph #2: ' + this.state.phone2 + ' '
            + 'Delvr to: ' + this.state.address;

        let newDescription = this.state.name + ' ordered ';

        // Ivan ordered 5 white large shirts

        //GET ORDERED BY
        let enteredBy = 'normalUser@printboda.com';
        if (this.state.user && this.state.user !== '' && this.state.user.email) {
            console.log("ux1 user.email is valid and there:" + this.state.user.email);
            enteredBy = this.state.user.email;
        }


        let newOrder = {
            itemType: this.state.itemSelected,
            quantity: this.state.quantity,
            email: this.state.email,
            orderEntryComplete: 'no',
            status: 'new',
            phone: this.state.phone,
            phone2: this.state.phone2,
            name: this.state.name,
            address: this.state.address,
            special_instructions: this.state.special_instructions,
            adset: this.state.adset,
            pricing_notes: this.state.pricing_notes,
            dateString: now,
            dateNum: d.getTime(),
            //IMAGE
            imageUploaded: this.state.uploadComplete,
            imageUrl: this.state.imageUrl,
            //T-SHIRTS
            shirtColor: 'blank',
            shirtSize: 'blank',
            // shirtText: 'blank',
            shirtText: this.state.shirtText,
            shirtBackText: this.state.shirtBackText,
            shirtType: 'blank',
            description: description,
            order_num: tempOrderNum,
            shirtSizeAndQtys: this.state.shirtSizeAndQtys,
            enteredBy: enteredBy,
            couponCode: this.state.couponCode,
        }

        //TOTAL SHIRTS
        let tempTotalShirts = 0;

        /**
         * ORDER 1
         */
        let order1 = {};
        if (this.state.shirtColor1 != '' && this.state.shirtSize1 != '' && this.state.shirtType1 != '' && this.state.qty1 != '') {
            console.log("order 2 is valid");
            order1.shirtColor = this.state.shirtColor1;
            order1.shirtSize = this.state.shirtSize1;
            order1.shirtType = this.state.shirtType1;
            order1.qty = this.state.qty1
            //  newOrder.order1 = order1;
            //tempNumOrders++;
            tempTotalShirts += parseInt(order1.qty);

            //SAVE JERSEY NUMBER
            if (this.state.jerseyNumber1 != '') {
                order1.jerseyNumber = this.state.jerseyNumber1;
                // newOrder.jerseyNumber = '';
                newOrder.jerseyNumber = this.state.jerseyNumber1 + ' ';
            }

            //SAVE JERSEY NAME
            if (this.state.jerseyName1 != '') {
                order1.jerseyName = this.state.jerseyName1;
                // newOrder.jerseyNumber = '';
                newOrder.jerseyName = this.state.jerseyName1 + ' ';
            }

            //SAVE JERSEY NAME
            if (this.state.teamSelection1 != '') {
                order1.teamSelection = this.state.teamSelection1;
                // newOrder.jerseyNumber = '';
                newOrder.teamSelection = this.state.teamSelection1 + ' ';
            }

            //SAVE TYPED IN FEILD NAME
            if (this.state.typedInTeamName1 != '') {
                order1.typedInTeamName = this.state.typedInTeamName1;
                // newOrder.jerseyNumber = '';
                newOrder.typedInTeamName1 = this.state.typedInTeamName1 + ' ';
            }

            //SAVE CHILDS AGE
            if (this.state.childsAge1 != '') {
                order1.childsAge = this.state.childsAge1;
                // newOrder.jerseyNumber = '';
                newOrder.childsAge = this.state.childsAge1 + ' ';
            }

            //ADD DESCRIPTIONS
            newDescription += this.getOrderDescription(order1, this.state.itemSelected) + " and ";
            console.log("dx1 newDescription:" + newDescription);

            newOrder.order1 = order1;
        }

        /**
         * ORDER 2
         */
        let order2 = {};
        if (this.state.shirtColor2 != '' && this.state.shirtSize2 != '' && this.state.shirtType2 != '' && this.state.qty2 != '') {
            console.log("order 2 is valid");
            order2.shirtColor = this.state.shirtColor2;
            order2.shirtSize = this.state.shirtSize2;
            order2.shirtType = this.state.shirtType2;
            order2.qty = this.state.qty2
            newOrder.order2 = order2;
            // tempNumOrders++;
            tempTotalShirts += parseInt(order2.qty);

            //SAVE JERSEY NUMBER
            if (this.state.jerseyNumber2 != '') {
                order2.jerseyNumber = this.state.jerseyNumber2;
                newOrder.jerseyNumber += this.state.jerseyNumber2 + ' ';
            }

            //SAVE JERSEY NAME
            if (this.state.jerseyName2 != '') {
                order2.jerseyName = this.state.jerseyName2;
                newOrder.jerseyName += this.state.jerseyName2 + ' ';
            }

            //SAVE TEAM SELECTION
            if (this.state.teamSelection2 != '') {
                order2.teamSelection = this.state.teamSelection2;
                // newOrder.jerseyNumber = '';
                newOrder.teamSelection += this.state.teamSelection2 + ' ';
            }

            //SAVE TYPED IN FEILD NAME
            if (this.state.typedInTeamName2 != '') {
                order2.typedInTeamName = this.state.typedInTeamName2;
                // newOrder.jerseyNumber = '';
                newOrder.typedInTeamName += this.state.typedInTeamName2 + ' ';
            }

            //SAVE TYPED IN childs age..
            if (this.state.childsAge2 != '') {
                order2.childsAge = this.state.childsAge2;
                // newOrder.jerseyNumber = '';
                newOrder.childsAge += this.state.childsAge2 + ' ';
            }

            //ADD DESCRIPTIONS
            newDescription += this.getOrderDescription(order2, this.state.itemSelected) + " and ";
            console.log("dx1 newDescription:" + newDescription);
        }

        /**
         * ORDER 3
         */
        let order3 = {};
        if (this.state.shirtColor3 != '' && this.state.shirtSize3 != '' && this.state.shirtType3 != '' && this.state.qty3 != '') {
            console.log("order 2 is valid");
            order3.shirtColor = this.state.shirtColor3;
            order3.shirtSize = this.state.shirtSize3;
            order3.shirtType = this.state.shirtType3;
            order3.qty = this.state.qty3
            newOrder.order3 = order3;

            //tempNumOrders++;
            tempTotalShirts += parseInt(order3.qty);

            //SAVE JERSEY NUMBER
            if (this.state.jerseyNumber3 != '') {
                order3.jerseyNumber = this.state.jerseyNumber3;
                newOrder.jerseyNumber += this.state.jerseyNumber3 + ' ';
            }

            //SAVE JERSEY NAME
            if (this.state.jerseyName3 != '') {
                order3.jerseyName = this.state.jerseyName3;
                newOrder.jerseyName += this.state.jerseyName3 + ' ';
            }

            //SAVE TEAM SELECTION
            if (this.state.teamSelection3 != '') {
                order3.teamSelection = this.state.teamSelection3;
                // newOrder.jerseyNumber = '';
                newOrder.teamSelection += this.state.teamSelection3 + ' ';
            }

            //SAVE TYPED IN FEILD NAME
            if (this.state.typedInTeamName3 != '') {
                order3.typedInTeamName = this.state.typedInTeamName3;
                // newOrder.jerseyNumber = '';
                newOrder.typedInTeamName += this.state.typedInTeamName3;
            }

            //SAVE TYPED IN childs age..
            if (this.state.childsAge3 != '') {
                order3.childsAge = this.state.childsAge3;
                // newOrder.jerseyNumber = '';
                newOrder.childsAge += this.state.childsAge3 + ' ';
            }

            //ADD DESCRIPTIONS
            newDescription += this.getOrderDescription(order2, this.state.itemSelected) + " and ";
            console.log("dx1 newDescription:" + newDescription);
        }

        newOrder.numOrders = this.state.numOrders;
        newOrder.totalShirts = this.countTotalShirts();
        console.log("tempNumOrders:" + tempNumOrders);

        //SET DESCRIPTION
        newOrder.description = newDescription;

        // this.setState({numOrders:tempNumOrders});
        return newOrder;
    }

    changeOrder = () => {
        this.setState({
            orderConfirming: false
        })
    }

    /**
     * OPEN OR CLOSE MODAL
     */
    handleOpen = () => this.setState({ modalOpen: true })

    handleClose = () => {

        this.setState({ modalOpen: false })
    }


    /**
     * SAVE ORDER IN FIREBASE
     */
    saveOrder = () => {
        console.log("fixx1 +++++++ saveOrder");
        //CHANGE UI
        //UPDATE  ORDER COMPLETE
        this.setState({
            // newPostKey: newPostKey,
            orderComplete: true,
            orderConfirming: false,
        });

        // ref.child('orders').push(data, response => response); 

        // let newPostKey = ref.child('orders').push().key;
        // console.log("newPostKey:" + newPostKey);
        // // this.setState({ newPostKey: newPostKey });

        // ref.child('orders/' + newPostKey).set(this.getNewOrderObject());

        // getOrderNumberAndUpdateCounter(this.getOrderNumberAndSaveOrder);

        //NEW
        console.log("orderx1 -------------- getOrderNumberAndUpdateCounterNew(getOrderNumberAndSaveOrder, this.getNewOrderObjectForNewSaveFunction())");
        getOrderNumberAndUpdateCounterNew(getOrderNumberAndSaveOrder, this.getNewOrderObjectForNewSaveFunction())
        console.log("orderx1 -------------- AFTER...");
        // //UPDATE  ORDER COMPLETE
        // this.setState({
        //     newPostKey: newPostKey,
        //     orderComplete: true,
        //     orderConfirming: false,
        // });
    }

    /**
    * GET NEW ORDER OBJEC TO PASS TO SAVE FUNCTION..
    */
    getNewOrderObjectForNewSaveFunction() {
        console.log("orderx12 ++++++++ - getNewOrderObjectForNewSaveFunction");

        let orderObject = {
            itemSelected: this.state.itemSelected,
            user: this.state.user,
            name: this.state.name,
            admin: this.state.admin,
            numOrders: this.state.singleOrderArray.length,
            phone: this.state.phone,
            phone2: this.state.phone2,
            address: this.state.address,
            email: this.state.email,
            special_instructions: this.state.special_instructions,
            adset: this.state.adset,
            pricing_notes: this.state.pricing_notes,
            shirtSizeAndQtys: this.state.shirtSizeAndQtys,
            singleOrderArray: this.state.singleOrderArray,
            replacement: this.state.replacement,
            replacementReason: this.state.replacementReason,
            orderSource: this.state.orderSource,
            bringJersey: this.state.bringJersey,
            orderType: this.state.orderType,
            gender: this.state.gender,
            sendNewOrderSms: this.state.sendNewOrderSms,
            couponCode: this.state.couponCode,
            salesPerson: this.state.salesPerson,
            sendDesignToSales: this.state.sendDesignToSales
        }

        //set OrderType for Cranes / football
        if (this.state.itemSelected === 'cranes') {
            orderObject.orderType = 'cranes'
        } else if (this.state.itemSelected === 'football') {
            orderObject.orderType = 'football'
        }

        if (this.state.algoliaUser != '' && this.state.algoliaUser.sales) {
            console.log("sendDesignToSales13  algoliaUser sales is true:");

            orderObject.salesPerson = this.state.algoliaUser.normalName;
            console.log("sendDesignToSales15  orderObject.salesPerson:" + orderObject.salesPerson)

            orderObject.salesPerson_phone = this.state.algoliaUser.phone;
            console.log("sendDesignToSales15  orderObject.salesPerson_phone:" + orderObject.salesPerson_phone);

            if (this.state.sendDesignToSales) {
                console.log("sendDesignToSales1 is true:" + this.state.sendDesignToSales);

                orderObject.sendDesignToSales = true;
                console.log("sendDesignToSales15  orderObject.sendDesignToSales:" + orderObject.sendDesignToSales)


            } else {
                console.log("sendDesignToSales2 is false:" + this.state.sendDesignToSales);
                orderObject.sendDesignToSales = false;
            }

        }

        console.log("orderx13 new order object:" + JSON.stringify(orderObject, null, 3));
        return orderObject
    }

    showMainForm = (itemType, itemTypeDescription, cardObject) => {
        console.log("vcx1 obx4 main ++++++++showMainForm itemType:" + itemType + " itemTypeDescription:" + itemTypeDescription);
        console.log("obx41 cardObject:" + JSON.stringify(cardObject, null, 3));

        /**
         * SET SHIRT TYPES..
         */
        this.setShirtColorTypes(itemType);

        var eventProperties = {
            'selection': itemType,
            admin: this.state.admin
        }
        //ReactGA.pageview('/orderForm/' + itemType);

        if (this.state.admin && this.state.admin === true) {
            console.log("vcx14 its an admin NOT loading pixel view content...");
        } else {
            //facebook loggins.. 
            console.log("vcx15 its an NOT admin loading pixel view content...");
            console.log("vcx16: ViewContent, itemType:" + itemType);
        }


        //SET STATE BASED ON CARDOBJECT
        this.setState({
            itemTypeSelected: true,
            itemSelected: cardObject.itemType,
            itemTypeDescription: cardObject.itemTypeDescription,
            modalOpen: false,
            wordsOnItemLabel: cardObject.wordsOnItemLabel,
            wordsOnBackItemLabel: cardObject.wordsOnBackItemLabel,
            itemPrice: cardObject.itemPrice,
            cardObject: cardObject
        })


        /**
         * IF ANYTHING OTHER THAN T-SHIRTS IS 
         * SELECTED THEN SHOW MODAL FOR T-SHRITS GOT TO NEXT
         */
        if (itemType === 't-shirts') {
            console.log("itemType === 't-shirts' && itemType === 't-shirts'");
            this.setState({
                itemTypeSelected: true,
                itemSelected: itemType,
                itemTypeDescription: itemTypeDescription,
                modalOpen: false,
                wordsOnItemLabel: 'What words do you want on your shirt?',
                wordsOnBackItemLabel: 'Do you want any words on the back of your shirt?',
                itemPrice: '40,000'
            })

        } else if (itemType === 'cranes') {
            console.log("itemType === 't-shirts'");
            this.setState({
                itemTypeSelected: true,
                itemSelected: itemType,
                itemTypeDescription: itemTypeDescription,
                modalOpen: false,
                specialItems: true,
                wordsOnItemLabel: 'What name do you want the back of your Cranes shirt?',
                wordsOnBackItemLabel: '',
                //SET SHIRT TYPE TO CRANTED
                shirtType1: 'cranes',
                shirtType2: 'cranes',
                shirtType3: 'cranes',
                itemPrice: '45,000'
            })
        } else if (itemType === 'football') {
            console.log("itemType === 'football'");
            this.setState({
                itemTypeSelected: true,
                itemSelected: itemType,
                itemTypeDescription: itemTypeDescription,
                modalOpen: false,
                specialItems: true,
                wordsOnItemLabel: 'What name do you want the back of your Jersey?',
                wordsOnBackItemLabel: '',
                //SET SHIRT TYPE TO CRANTED
                shirtType1: 'football',
                shirtType2: 'football',
                shirtType3: 'football',
                itemPrice: '45,000'
            })
        } else if (itemType === 'jumper') {
            console.log("itemType === 'football'");
            this.setState({
                itemTypeSelected: true,
                itemSelected: itemType,
                itemTypeDescription: itemTypeDescription,
                modalOpen: false,
                wordsOnItemLabel: 'What words do you want on your jumper?',
                wordsOnBackItemLabel: 'Do you want any words on the back of your jumper?',
                itemPrice: '65,000',
                shirtType1: 'jumper',
                shirtType2: 'jumper',
                shirtType3: 'jumper',
            })
        }
        else if (itemType === 'vest') {
            console.log("itemType === 'vest'");
            this.setState({
                itemTypeSelected: true,
                itemSelected: itemType,
                itemTypeDescription: itemTypeDescription,
                modalOpen: false,
                wordsOnItemLabel: 'What words do you want on your vest?',
                wordsOnBackItemLabel: 'Do you want any words on the back of your vest?',
                itemPrice: '35,000',
                shirtType1: 'vest',
                shirtType2: 'vest',
                shirtType3: 'vest',
            })
        }

        else if (itemType === 'flag') {
            console.log("itemType === 'flag'");
            this.setState({
                itemTypeSelected: true,
                itemSelected: itemType,
                itemTypeDescription: itemTypeDescription,
                modalOpen: false,
                wordsOnItemLabel: 'What words would you like on your flag',
                wordsOnBackItemLabel: '',
                itemPrice: '100,000',
                shirtType1: 'flag',
                shirtType2: 'flag',
                shirtType3: 'flag',
                //SHIRT SIZES HAVE TO BE SIMULATE FOR A CUP
                shirtSize1: 'flag',
                shirtSize2: 'flag',
                shirtSize3: 'flag',
            })
        }



    }

    amp_logFieldClick = (e) => {
        console.log("clx1 logClicked.....");
        console.log("hx32 e.target.name:" + e.target.name);

        var eventProperties = {
            'fieldClicked': e.target.name,
            admin: this.state.admin
        }

        console.log("clx12 fieldvar:" + JSON.stringify(eventProperties));

    }

    amp_logOrderPlaced = (itemOrdered) => {

        //let eventProperties = {};
        var eventProperties = {
            itemType: this.state.itemSelected,
            itemOrdered: itemOrdered,
            // quantity: this.state.quantity,
            // shirtColor: this.state.shirtColor,
            // shirtSize: this.state.shirtSize,
            // shirtType: this.state.shirtType,
            imageUploaded: this.state.uploadComplete,
            admin: this.state.admin,
            totalShirts: this.getNewOrderObject().totalShirts,
            numOrders: this.state.numOrders,
        }

        //this.facebookLogOrderPlaced();

    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    /**
     * HANDLE INPUTS FROM SIZE AND IMAGE CHANGES
     */
    handleSizeAndQtyInputFeildChanges = (e) => {
        console.log("sq1: handleSizeAndQtyInputFeildChanges;");
        console.log("sq12 name:" + e.target.name);
        console.log("sq13 value:" + e.target.value);

        let tempShirtSizeAndQtys = {};
        tempShirtSizeAndQtys[e.target.name] = e.target.value;

        console.log("sq14 tempShirtSizeAndQtys:" + JSON.stringify(tempShirtSizeAndQtys));

        this.setState({ shirtSizeAndQtys: tempShirtSizeAndQtys });
    }

    cancelOrder = () => {
        let eventProperties = {
            admin: this.state.admin
        }

        this.setState({
            itemTypeSelected: false
        })
    }


    backHome = () => {
        let eventProperties = {
            admin: this.state.admin
        }

        this.setState({
            itemTypeSelected: false
        })
    }

    /**
     * RADIO BUTTON FUNCTIONS
     */
    handleShirtSizeRadionButtons = (e, { name, value }) => {
        console.log("stx1 >>>>: handleShirtSizeButton clicked");
        console.log("stx12 e.target.name:" + e.target.name);
        console.log("stx13 value:" + value);
        console.log("stx14 name:" + name);

        var eventProperties = {
            'fieldClicked': 't_shirt_size',
            'sizeSelected': value,
            'admin': this.state.admin,

        }

        this.setState({
            shirtSize: value
        });
    }

    /**
     * shirt color radio change function
     */
    handleShirtColorRadionButtons = (e, { name, value }) => {
        console.log("stx1 >>>>: handleShirtColorRadionButtons clicked");
        console.log("stx12 e.target.name:" + e.target.name);
        console.log("stx13 value:" + value);
        console.log("stx14 name:" + name);

        var eventProperties = {
            'fieldClicked': 't_shirt_color',
            'colorSelected': value,
            'admin': this.state.admin
        }


        this.setState({
            shirtColor: value
        });
    }

    /**
    * shirt color radio change function
    */
    handleShirtTypeRadionButtons = (e, { name, value }) => {
        console.log("stx1 >>>>: handleShirtTypeRadionButtons clicked");
        console.log("stx12 e.target.name:" + e.target.name);
        console.log("stx13 value:" + value);
        console.log("stx14 name:" + name);

        var eventProperties = {
            'fieldClicked': 't_shirt_type',
            'typeSelected': value,
            'admin': this.state.admin
        }



        this.setState({
            shirtType: value
        });
    }


    /**
     * WHEN FILE UPLOAD IS COMPLETE
     */
    /**
    * UPDATE STATE WHEN FILE UPLOAD IS COMPLETE
    */
    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url
        });
    }


    handleOrderDetailsDropDownChanges = (value) => { 
        console.log('gbv1 sendDesignToSales You\'ve sss:', value);
        console.log('gbv12 sendDesignToSales You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category] = value.value;

        this.setState(newState);
    }

    /**
    * HANDLE DROPDOWN FOR ORDER ONE
    */
    handleOrderDetailsDropDownChangesOrderOne = (value) => {
        console.log("hdx1 handleOrderDetailsDropDownChangesOrderOne");
        console.log('hdx12 You\'ve sss:', value);
        console.log("hdx13 category alone:" + value.category);
        console.log("hdx14 category:" + value.category + '1');
        console.log('hdx15 You\'ve selected:', value.value + " " + value.category);
        console.log("hdx16 -  this.props.itemSelected:" + this.state.itemSelected);

        let newState = {};
        newState[value.category + '1'] = value.value;
        console.log("newState 1:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);

        //LOG FOOTBALL ELECTIONS
        if (value.category === 'teamSelection') {
            console.log("fbx1 teamSelection dropdown - " + value.value);
            console.log("fbx12 colors of team:" + JSON.stringify(value.colors))

            // this.setState({
            //     selectedTeamColors1:value.colors
            // })
            this.getTeamJerseyColors(value.value, '1');

            this.logAmplitudeFootBallDropdownSelection(value.value);

        } else if (value.category === 'shirtColor' && this.state.itemSelected === 'football') {
            console.log("jbx1 shirtColor dropdown - " + value.value);
            console.log("jbx12 colors of team:" + JSON.stringify(value.colors))

            this.setState({
                selectedTeamColors1: value
            })
        }
    }


    handleOrderDetailsDropDownChangesOrderTwo = (value) => {
        console.log("handleOrderDetailsDropDownChangesOrderTwo");
        console.log('gbv2 You\'ve sss:', value);
        console.log("plus 2:" + value.category + '2');
        console.log('gbv22 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category + '2'] = value.value;
        console.log("newState 2:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
        //LOG FOOTBALL ELECTIONS
        if (value.category === 'teamSelection') {
            this.getTeamJerseyColors(value.value, '2');
            this.logAmplitudeFootBallDropdownSelection(value.value);

        } else if (value.category === 'shirtColor' && this.state.itemSelected === 'football') {
            console.log("fbx1 shirtColor dropdown - " + value.value);
            console.log("fbx12 colors of team:" + JSON.stringify(value))

            this.setState({
                selectedTeamColors2: value
            })
        }
    }

    handleOrderDetailsDropDownChangesOrderThree = (value) => {
        console.log("handleOrderDetailsDropDownChangesOrderThree");
        console.log('gbv32 You\'ve sss:', value);
        console.log("plus32:" + value.category + '3');
        console.log('gbv32 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category + '3'] = value.value;
        console.log("newState 3:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
        //LOG FOOTBALL ELECTIONS
        if (value.category === 'teamSelection') {
            this.getTeamJerseyColors(value.value, '3');
            this.logAmplitudeFootBallDropdownSelection(value.value);

        } else if (value.category === 'shirtColor' && this.state.itemSelected === 'football') {
            console.log("fbx1 shirtColor dropdown - " + value.value);
            console.log("fbx12 colors of team:" + JSON.stringify(value))

            this.setState({
                selectedTeamColors3: value
            })
        }
    }

    handleFootballDropDownChange = (value) => {
        console.log("handleFootballDropDownChange");
        console.log('gbv32 You\'ve sss:', value);
        console.log("plus32:" + value.category);
        console.log('gbv32 You\'ve selected:', value.value);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);

        let eventProperties = {
            teamSelected: value.value,
            admin: this.state.admin
        }


    }

    logAmplitudeFootBallDropdownSelection = (value) => {

        let eventProperties = {
            teamSelected: value,
            admin: this.state.admin
        }

    }

    /**
     * MAKE THE NEXT ORDER SECTION VISIBLE
     */
    handleAddMoreClick = (orderChoice) => {
        console.log("++++++:handleAddMoreClick - orderChoice:" + orderChoice);

        if (orderChoice === 'Order 1') {
            let tempNumOrders = this.state.numOrders;
            tempNumOrders++;
            this.setState({
                order2Visible: true,
                numOrders: tempNumOrders
            });

            let eventProperties = {
                orderSection: 1,
                'admin': this.state.admin
            }



        } else if (orderChoice === 'Order 2') {
            let tempNumOrders = this.state.numOrders;
            tempNumOrders++;
            this.setState({
                order3Visible: true,
                numOrders: tempNumOrders
            });

            let eventProperties = {
                orderSection: 2,
                'admin': this.state.admin
            }



        } else {
            console.log("uknown orderChoice");
        }
    }

    render() {


        //main logo
        const logo = require('../../images/printbodalogo_large.png');
       // const logo = <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/closureNotices%2FPrintboda%20-%20covid%20-%20closed_5_siteImage-min.jpg?alt=media&token=432231de-4ede-40dc-a04d-701aa9e58cfa' />

        return (
            // { MainUi }


            !this.state.itemTypeSelected
                ? <div>
                    <LandingPageCards
                        showMainForm={this.showMainForm}
                        firstCardKey={this.props.match.params.campaign}
                        specialEntry={this.props.match.params.specialEntry}
                        admin={this.state.admin}
                        adset={this.state.adset} />
                    {/* LANDING PAGE MODAL */}
                    <LandingPageModal
                        handleOpen={this.handleOpen}
                        handleClose={this.handleClose}
                        modalOpen={this.state.modalOpen}
                        itemSelected={this.state.itemSelected} />
                </div>
                : <div>

                    {/* NORMAL ORDER FORM */}
                    <OrderFormUI
                        orderConfirming={this.state.orderConfirming}
                        logo={logo}
                        submitForm={this.submitForm}
                        amp_logFieldClick={this.amp_logFieldClick}
                        handleTextInputChange={this.handleTextInputChange}
                        itemTypeDescription={this.state.itemTypeDescription}
                        cancelOrder={this.cancelOrder}
                        backHome={this.backHome}
                        specialItems={this.state.specialItems}
                        wordsOnItemLabel={this.state.wordsOnItemLabel}
                        wordsOnBackItemLabel={this.state.wordsOnBackItemLabel}
                        itemSelected={this.state.itemSelected}
                        //SHIRT DETAILS
                        shirtSize={this.state.shirtSize}
                        shirtColor={this.state.shirtColor}
                        shirtType={this.state.shirtType}
                        handleShirtSizeRadionButtons={this.handleShirtSizeRadionButtons}
                        handleShirtColorRadionButtons={this.handleShirtColorRadionButtons}
                        handleShirtTypeRadionButtons={this.handleShirtTypeRadionButtons}
                        //FORM FILED VALUEDS
                        quantity={this.state.quantity}
                        shirtSize={this.state.shirtSize}
                        shirtColor={this.state.shirtColor}
                        shirtText={this.state.shirtText}
                        shirtBackText={this.state.shirtBackText}
                        shirtType={this.state.shirtType}
                        email={this.state.email}
                        phone={this.state.phone}
                        phone2={this.state.phone2}
                        name={this.state.name}
                        address={this.state.address}
                        special_instructions={this.state.special_instructions}
                        pricing_notes={this.state.pricing_notes}

                        //FORM VALIDATION
                        validateForm={this.validateForm}
                        formHasError={this.state.formHasError}
                        formErrors={this.state.formErrors}
                        formErrorFieldArray={this.state.formErrorFieldArray}
                        //RADIO GROUP ERRORS
                        shirtSizeError={this.state.shirtSizeError}
                        shirtColorError={this.state.shirtColorError}
                        shirtTypeError={this.state.shirtTypeError}
                        //SAVING / CONFIRMING
                        saveOrder={this.saveOrder}
                        changeOrder={this.changeOrder}
                        newOrderObject={this.getNewOrderObject()}
                        orderComplete={this.state.orderComplete}
                        //FILE UPLOAD
                        updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                        imageUrl={this.state.imageUrl}

                        //SIZE AND QTY
                        handleOrderDetailsDropDownChanges={this.handleOrderDetailsDropDownChanges}
                        shirtColor={this.state.shirtColor}
                        shirtSize={this.state.shirtSize}

                        //ORDER 1
                        handleOrderDetailsDropDownChangesOrderOne={this.handleOrderDetailsDropDownChangesOrderOne}
                        shirtColor1={this.state.shirtColor1}
                        shirtSize1={this.state.shirtSize1}
                        shirtType1={this.state.shirtType1}
                        qty1={this.state.qty1}
                        jerseyNumber1={this.state.jerseyNumber1}
                        jerseyName1={this.state.jerseyName1}
                        //FOOTBACLL
                        teamSelection1={this.state.teamSelection1}
                        selectedTeamColors1={this.state.selectedTeamColors1}
                        shirtColors1={this.state.shirtColors1}
                        typedInTeamName1={this.state.typedInTeamName1}
                        //CHILD
                        childsAge1={this.state.childsAge1}

                        //ORDER VISIBILITY
                        // order2Visible={this.state.order2Visible}
                        // order3Visible={this.state.order3Visible}
                        handleAddMoreClick={this.handleAddMoreClick}

                        //NUMBER OF ORDERS
                        numOrders={this.state.numOrders}

                        //ITEM PRICE
                        itemPrice={this.state.itemPrice}

                        //SHIRT SIZES.
                        shirtSizes={shirtSizes}

                        //UPDATE ORDER ARRAY
                        updateSingleOrderArray={this.updateSingleOrderArray}
                        admin={this.state.admin}

                        //NEW ORDER OPTIONS
                        //REPLACEMENT
                        replacement={this.state.replacement}
                        replacementOptions={replacementOptions}
                        //REPLACEMENT REASON
                        replacementReasonOptions={replacementReasonOptions}
                        replacementReason={this.state.replacementReason}
                        //ORDER SOURCE
                        orderSourceOptions={orderSourceOptions}
                        orderSource={this.state.orderSource}
                        //BRING JERSEY
                        //REPLACEMENT
                        bringJersey={this.state.bringJersey}
                        bringJerseyOptions={bringJerseyOptions}
                        //ORDER TYPE
                        orderType={this.state.orderType}
                        orderTypeOptions={orderTypeOptions}
                        gender={this.state.gender}
                        genderOptions={genderOptions}
                        //CARD OBJECT FROM ALGOLIA 
                        // 4x1
                        cardObject={this.state.cardObject}
                        sendNewOrderSms={this.state.sendNewOrderSms}
                        sendNewOrderSmsOptions={sendNewOrderSmsOptions}
                        couponCode={this.state.couponCode}

                        salesPerson={this.state.salesPerson}
                        salesPeopleChoices={this.state.salesPeopleChoices}
                        algoliaUser={this.state.algoliaUser}
                        sendDesignToSales={this.state.sendDesignToSales}
                        sendDesignToSalesOptions={this.state.sendDesignToSalesOptions}
                    />


                    {/* SHOWS WHEN CONFRIMING ORDER */}
                    <NewConfirmOrder
                        saveOrder={this.saveOrder}
                        changeOrder={this.changeOrder}
                        newOrderObject={this.getNewOrderObject()}
                        orderConfirming={this.state.orderConfirming}
                        singleOrderArray={this.state.singleOrderArray} />

                    {/* SHOWS WHEN ORDER COMPLETE */}
                    <OrderComplete
                        newOrderObject={this.getNewOrderObject()}
                        orderComplete={this.state.orderComplete}
                        orderNum={this.state.orderNum} />


                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/orderForm.js